module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/zeroHeroes-709919bdc35c19934481c5a402c44ecc.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/zeroHeroes.png
// module id = 2508
// module chunks = 2